var toPositiveInteger = require('../internals/to-positive-integer');

module.exports = function (it, BYTES) {
  var offset = toPositiveInteger(it);
  if (offset % BYTES) throw RangeError('Wrong offset');
  return offset;
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/to-offset.js
// module id = 304
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33